import { get, intersection, some } from 'lodash-es'

import { GlobalPrivilege, OrgPrivilege, OrgPrivileges, User } from '@percept/types'

type PrivilegeOperator = 'ALL' | 'ANY'

const defaultPrivilegeOperator: PrivilegeOperator = 'ANY'

const checkPrivileges = (
  requiredPrivileges: string[],
  assignedPrivileges: string[] | undefined | null,
  operator: PrivilegeOperator,
): boolean => {
  if( !assignedPrivileges ){
    return false
  }
  if( operator === 'ANY' ){
    return !!(
      intersection(assignedPrivileges, requiredPrivileges).length
    )
  }
  for( const requiredPrivilege of requiredPrivileges ){
    if( assignedPrivileges.includes(requiredPrivilege) ){
      return true
    }
  }
  return false
}


export const userHasOrgPrivileges = (
  requiredOrgPrivileges: OrgPrivilege[],
  orgUnitId: string | null,
  userOrgPrivileges: OrgPrivileges[] | undefined | null,
  operator: PrivilegeOperator = defaultPrivilegeOperator,
): boolean => (
  checkPrivileges(
    requiredOrgPrivileges,
    get((userOrgPrivileges || []).find( p => p.org_id === orgUnitId ), 'privileges', null),
    operator,
  )
)

export const getPrivilegedOrgUnitIds = (
  requiredOrgPrivileges: OrgPrivilege[],
  userOrgPrivileges: OrgPrivileges[] | undefined | null,
  operator: PrivilegeOperator = defaultPrivilegeOperator,
): string[] => (
  (userOrgPrivileges || []).reduce( (acc, p) => {
    if( checkPrivileges(requiredOrgPrivileges, p.privileges, operator) ){
      acc.push(p.org_id)
    }
    return acc
  }, [] as string[])
)


export const userHasAnyOrgPrivileges = (
  requiredOrgPrivileges: OrgPrivilege[],
  userOrgPrivileges: OrgPrivileges[] | undefined | null,
  operator: PrivilegeOperator = defaultPrivilegeOperator,
): boolean => {
  if( !userOrgPrivileges || !userOrgPrivileges.length ){
    return false
  }
  return some(
    userOrgPrivileges,
    (o: OrgPrivileges) => (
      checkPrivileges(
        requiredOrgPrivileges,
        o.privileges,
        operator
      )
    )
  )
}


export const userHasGlobalPrivileges = (
  requiredGlobalPrivileges: GlobalPrivilege[],
  userGlobalPrivileges: GlobalPrivilege[] | undefined | null,
  operator: PrivilegeOperator = defaultPrivilegeOperator,
): boolean => (
  checkPrivileges(
    requiredGlobalPrivileges,
    userGlobalPrivileges,
    operator,
  )
)


export const isAdminUser = (user: User): boolean => (
  (user && user.groups || []).includes('Admins')
)
